<!--  -->
<template>
  <div>
    <div class="selcet_box">
      <el-input
        v-model="query.keyword"
        placeholder="请输入实例名称"
        style="margin: 0px 10px 0px 0px; width: 300px"
      />
      <el-input
        v-model="query.group_id"
        placeholder="请输入组id"
        style="margin: 0px 10px 0px 0px; width: 300px"
      />
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="searchclick"
      >搜索</el-button>
      <el-button
        type="info"
        icon="el-icon-refresh-right"
        @click="rechargeclick"
      >重置</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="实例id"
        width="130"
        align="center"
      />
      <el-table-column
        prop="group_id"
        label="组id"
        width="130"
        align="center"
      />
      <el-table-column
        prop="region_name"
        label="区域"
        width="130"
        align="center"
      />
      <el-table-column
        v-show="login_type == 2 || login_type == 3"
        prop="pod_name"
        label="实例名称"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="login_type == 2">
            {{ scope.row.pod_name }}
          </div>
          <div v-if="login_type == 3">
            {{ scope.row.sn }}
          </div>
          <div v-if="login_type == 4">
            {{ scope.row.instance_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="login_type == 4"
        prop="instance_id"
        label="阿里云实例id"
        width="180"
        align="center"
      />
      <el-table-column
        prop="online_text"
        label="实例状态"
        width="180"
        align="center"
      />
      <el-table-column
        prop="bind_status_text"
        label="运行状态"
        width="150"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="chooser(scope.row)"
          >选择</el-button>
          <el-button
            v-if="login_type == 3 || login_type == 4"
            type="primary"
            size="mini"
            plain
            @click="openCloudDesktop(scope.row, login_type)"
          >连接云桌面</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <CloudMobileDialog
      :visible.sync="aliyunDialogVisible"
      :connection-params="aliyunParams"
    />
    <TencentCloudMobileDialog
      :visible.sync="tencentDialogVisible"
      :connection-params="tencentParams"
    />
  </div>
</template>

<script>
import { yunlist, getAliTicket } from '@/api/enterprisewechatControl'
import PaginationRight from '@/components/PaginationRight/index.vue'
import CloudMobileDialog from './CloudMobileDialog.vue'
import TencentCloudMobileDialog from './TencentCloudMobileDialog.vue'
export default {
  components: { PaginationRight, CloudMobileDialog, TencentCloudMobileDialog },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        group_id: ''
        // keyword: ''
      },
      tableData: [],
      total: null,
      login_type: null,
      aliyunDialogVisible: false,
      tencentDialogVisible: false,
      aliyunParams: {},
      tencentParams: {}
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(login_type) {
      this.login_type = login_type
      this.list()
    },
    async list() {
      const data = await yunlist({ ...this.query, type: this.login_type })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    chooser(item) {
      // eslint-disable-next-line eqeqeq
      if (this.login_type == 2) {
        console.log('火山云')
        // eslint-disable-next-line eqeqeq
        if (item.bind_status == 2) {
          this.$confirm('当前实例已经绑定手机，您确定要选择吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.$emit('callback', item.pod_name, item.id)
            })
            .catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消删除'
              // })
            })
        } else {
          this.$emit('callback', item.pod_name, item.id)
        }
      // eslint-disable-next-line eqeqeq
      } else if (this.login_type == 3) {
        // eslint-disable-next-line eqeqeq
        if (item.bind_status == 2) {
          this.$confirm('当前实例已经绑定手机，您确定要选择吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.$emit('callback', item.sn, item.id)
            })
            .catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消删除'
              // })
            })
        } else {
          this.$emit('callback', item.sn, item.id)
        }
      } else {
        // eslint-disable-next-line eqeqeq
        if (item.bind_status == 2) {
          this.$confirm('当前实例已经绑定手机，您确定要选择吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.$emit('callback', item.instance_id, item.id)
            })
            .catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消删除'
              // })
            })
        } else {
          this.$emit('callback', item.instance_id, item.id)
        }
      }
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keyword = ''
      this.query.group_id = ''
      this.list()
    },
    async openCloudDesktop(row, login_type) {
      // eslint-disable-next-line eqeqeq
      if (login_type == 3) {
        // 腾讯云
        const sn = row.sn
        this.tencentParams = { sn }
        this.tencentDialogVisible = true
      } else {
        // 1. 取当前行设备编码
        const instance_id = row.instance_id
        try {
          // 2. GET 请求获取 ticket，axios 会把 { equipment_code } 作为查询参数
          const res = await getAliTicket({ instance_id })
          const { ticket, desktop_id: desktopId, real_desktop_id: realDesktopId, region_id: regionId } = res.data

          if (!ticket || !desktopId || !realDesktopId || !regionId) {
            this.$message.warning('接口返回参数不完整，请检查 ticket、desktop_id、real_desktop_id、region_id')
            return
          }

          // 3. 拿到 ticket 后再构造连接参数
          // 3. 构造云桌面连接参数
          this.aliyunParams = {
            ticket,
            desktopInfo: {
              desktopId,
              desktopName: '',
              realDesktopId,
              protocolType: 'ASP',
              loginRegionId: regionId,
              connConfig: { decodeType: 0 }
            },
            regionId,
            openType: 'inline',
            resourceType: 'local'
          }
          // 4. 打开弹窗
          this.aliyunDialogVisible = true
        } catch (err) {
          console.error('获取 ticket 失败：', err)
          this.$message.error('获取连接凭证失败，请重试')
        }
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.selcet_box {
  margin-bottom: 10px;
}
</style>
